export default {
  title: 'Mod aglomerat',
  form: {
    has_busy_mode: {
      label: 'Mod aglomerat',
    },
    busy_mode_minutes: {
      label: 'Cu cât timp să măriți timpul obișnuit de pregătire?',
      options: {
        10: '10 min',
        15: '15 min',
        20: '20 min',
        25: '25 min',
        30: '30 min',
        45: '45 min',
        60: '1 oră',
      },
    },
  },
  buttons: {
    save: 'Salvează',
  },
  toasts: {
    failed_to_save_changes: 'Nu s-au putut salva modificările',
    changes_got_saved: 'Modificările au fost salvate cu succes',
  },
};
